import React, {Component} from 'react';
import {connect} from 'react-redux';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import Translate, {t} from 'components/Translate';
import '../components/stylefeedback.css';

import {
    cancelAction as cancelActionRedux,
    proceedAction as proceedActionRedux,
} from '../services/confirmAction/action';
import {addUserToBlackList, getCategories, getConversationInfo, saveConversationInfo} from '../services/company/api';
import TranslateProperty from 'components/TranslateProperty';
import config from "../config";
import {addNotification as addNotificationAction} from '../services/notification/action';
import {updateUserData as updateUserDataAction} from "../services/user/action";
import {bindActionCreators} from "redux";
import SilverButton from "../components-new/buttons/SilverButton";
import BlueButton from "../components-new/buttons/BlueButton";
import Input from "../components-new/Input";

const style = {
    overlay: {
        backgroundColor: config.modalBackgroundColor,
        zIndex: '2000',
    },

    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        borderRadius: '20px',
        transform: 'translate(-50%, -50%)',
        padding: '40px',
        border: 'none', // width: '24%',
        minWidth: '396px',
        maxWidth: '450px',
    },

    title: {
        color: '#09183A', // fontSize: '18px',
        fontSize: '14px', marginBottom: '30px', marginTop: '30px', textAlign: 'center',
    },

    buttonsWrapper: {
        textAlign: 'center', marginTop: '15px',
    },

    confirmButton: {
        cursor: 'pointer', // width: '140px',
        width: '215px',
        border: 'none',
        borderRadius: '20px', // padding: '15px 45px',
        padding: '15px',
        backgroundColor: '#103c5b',
        color: '#FFFFFF',
        fontSize: '16px',
        WebkitBoxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
        MozBoxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
        boxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
        marginTop: '10px',
    },

    refuseButton: {
        cursor: 'pointer', // width: '140px',
        width: '128px',
        marginRight: '10px',
        border: 'none',
        borderRadius: '20px',
        backgroundColor: '#e5e5e559',
        color: '#09183A', // padding: '15px 45px',
        padding: '15px',
        fontSize: '16px',
        WebkitBoxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
        MozBoxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
        boxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
        marginTop: '10px',
    },

    //feedback
    topic_input: {
        display: 'block',
        backgroundColor: '#d2dae7',
        border: 'none',
        padding: '10px',
        fontSize: '16px',
        width: '100%',
        borderRadius: '10px',
    },

    select_category: {
        display: 'block',
        width: '100%',
        marginTop: '10px',
        backgroundColor: 'white',
        border: '1px solid rgb(221, 221, 221)',
        fontSize: '16px',
        padding: '10px',
        borderRadius: '10px',
        marginBottom: '10px',
    },

    textarea: {
        display: 'block',
        width: '100%',
        marginTop: '10px',
        border: 'none',
        backgroundColor: '#d2dae7',
        fontSize: '16px',
        padding: '10px',
        borderRadius: '10px',
        marginBottom: '10px',
        height: '140px',
        resize: 'none',
    }

};

const priorities = [{
    value: 'high', label: 'High', icon: '↑', color: '#cf0b0b', id: 1
}, {
    value: 'medium', label: 'Medium', icon: '↑', color: '#ec8f00', id: 2
}, {
    value: 'low', label: 'Low', icon: '↓', color: '#16b216', id: 3
}];

Modal.setAppElement('#root');

class ConfirmModalFeedback extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: [],
            selectedCategory: '',
            subject: '',
            description: '',
            priority: '',
            inProcess: false,
            selectedPriority: '',
            blackListSubject: '',
            blackListDescription: '',
            assignee: '',
            silentMod: false,
        };
    }

    closeModal = () => {
        const {cancelAction} = this.props;
        cancelAction();
    };

    componentDidMount() {
        let {conversation, isBlockUser, conv} = this.props;

        // ChatContact right click case
        if (conv && conv.companyId) {
            conversation = conv
        }
        //

        if (!isBlockUser) {
            getCategories(conversation.companyId)
                .then(categories => {
                    this.setState({categories});
                });
            getConversationInfo(conversation.id)
                .then(data => {
                    this.setState({
                        selectedCategory: data.categoryId,
                        subject: data.subject,
                        description: data.description,
                        selectedPriority: data.priority,
                        inProcess: data.inProcess,
                        isTicket: data.ticket,
                        assignee: data.assignedUser ? data.assignedUser.platformId : ''
                    });
                });
        }
    }

    handleInputChange = (event) => {
        const {
            name, value, type, checked
        } = event.target;
        this.setState({
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    handlePriorityChange = (event) => {
        this.setState({
            selectedPriority: event.target.value
        });
    };

    handleAssigneeChange = (event) => {
        this.setState({
            assignee: event.target.value
        });
    };

    addToBlackList = () => {
        const {
            blackListSubject, blackListDescription
        } = this.state;

        let {
            cancelAction, conversation, addNotification, conv
        } = this.props;

        // ChatContact right click case
        if (conv && conv.companyId) {
            conversation = conv
        }
        //

        const entity = {
            subject: blackListSubject,
            description: blackListDescription,
            userId: conversation.userId,
            companyId: conversation.companyId,
            platform: conversation.platform
        }


        addUserToBlackList(entity, conversation.companyId, conversation.id).then(d => {
            if (d.status === 226) {
                addNotification('userAlreadyInBlackList', config.notificationLevels.info);
            } else if (d.status === 200) {
                addNotification('userAddedInBlackList', config.notificationLevels.success);
            }
        }).catch(error => {
            console.log(error)
            addNotification('somethingWentWrong', config.notificationLevels.error);
        });

        cancelAction();
    }

    handleClick = () => {
        let {
            endConversation, cancelAction, conversation, isTicketDiv, user, addNotification, conv
        } = this.props;
        const {
            selectedCategory, subject, description, selectedPriority, inProcess, isTicket, assignee, silentMod
        } = this.state;

        // ChatContact right click case
        if (conv && conv.companyId) {
            conversation = conv
        }
        //

        saveConversationInfo(selectedCategory, subject, description, selectedPriority, inProcess, isTicket, conversation.id, assignee)
            .then(data => addNotification('convInfoCreated/Updated', config.notificationLevels.success))
            .catch(error => addNotification('somethingWentWrong', config.notificationLevels.error));

        if (!isTicketDiv) {
            if (conv && conv.companyId) { // ChatContact right click case
                endConversation(silentMod, conv);
            } else { // default end case by ConversationHeader
                endConversation(silentMod);
            }
        }
        cancelAction();
    };

    render() {
        const {
            isOpen, cancelAction, user, isTicketDiv, isBlockUser, users, tariff
        } = this.props;
        let {
            categories,
            subject,
            description,
            isTicket,
            selectedCategory,
            selectedPriority,
            blackListSubject,
            blackListDescription,
            assignee,
            silentMod
        } = this.state;


        const {features} = tariff
        categories = categories.filter(c => c.enabled === true)

        return (
            <Modal closeTimeoutMS={config.closeTimeoutMS} isOpen={isOpen} style={style}
                   onRequestClose={this.closeModal}>
                {isBlockUser &&
                    <div>
                        <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                            <h2 className="title_feedback"><Translate text="blockUser"/></h2>
                            <h5
                                style={{
                                    fontSize: '11px',
                                    marginBottom: '10px',
                                    marginLeft: '20px'
                                }}
                            ><Translate text="blockUserInfo"/></h5>
                        </div>

                        <TranslateProperty properties={[{
                            key: 'placeholder', value: 'reason'
                        }]}>
                            <Input
                                maxLength={150}
                                type="text"
                                name="blackListSubject"
                                value={blackListSubject}
                                onChange={(event) => this.setState({blackListSubject: event.target.value})}
                            />
                        </TranslateProperty>
                        <br/>
                        <br/>
                        <TranslateProperty properties={[{
                            key: 'placeholder', value: 'description'
                        }]}>
                            <Input
                                style={{minHeight: '200px'}}
                                isTextarea={true}
                                resize={'none'}
                                maxLength={5000}
                                name="blackListDescription"
                                value={blackListDescription}
                                onChange={(event) => this.setState({blackListDescription: event.target.value})}
                            />
                        </TranslateProperty>
                        <div className="buttons" style={style.buttonsWrapper}>
                            <SilverButton styles={{fontSize:'12px',marginRight:'20px'}} type={'button'} onClick={cancelAction}
                                          width={'25%'}
                                          children={<Translate text="cancel"/>}/>
                            <BlueButton styles={{fontSize:'12px'}} type={'button'} onClick={this.addToBlackList} width={'60%'}
                                        children={<Translate text="blockAndEnd"/>}/>
                        </div>
                    </div>}
                {!isBlockUser && <div className="wrapper" style={style.wrapper}>
                    {isTicketDiv && <h2 className="title_feedback"><Translate text="notes"/></h2>}
                    {!isTicketDiv && <h2 className="title_feedback"><Translate text="endConversation"/></h2>}

                    {features.includes(config.features.CATEGORIES) && (
                        <select
                            id="category_id"
                            name="selectedCategory"
                            style={style.select_category}
                            onChange={this.handleInputChange}
                            value={selectedCategory}
                        >
                            <option value="" disabled>
                                {t({text: 'category', user})}
                            </option>

                            {categories.map((category) => (
                                <option key={category.id} value={category.id}>
                                    {category.name}
                                </option>
                            ))}
                        </select>
                    )}

                    <TranslateProperty properties={[{key: 'placeholder', value: 'subject'}]}>
                        <Input
                            maxLength={150}
                            type="text"
                            name="subject"
                            value={subject || ''}
                            onChange={(event) => this.setState({subject: event.target.value})}
                        />
                    </TranslateProperty>


                    <br/>
                    <br/>


                    <TranslateProperty properties={[{
                        key: 'placeholder', value: 'description'
                    }]}>
                        <Input
                            style={{minHeight: '200px'}}
                            isTextarea={true}
                            resize={'none'}
                            maxLength={5000}
                            name="description"
                            value={description}
                            onChange={(event) => this.setState({description: event.target.value})}
                        />
                    </TranslateProperty>

                    <select
                        id="priority"
                        name="selectedPriority"
                        style={{
                            ...style.select_category,
                            color: selectedPriority
                                ? (function () {
                                    const match = priorities.find(p => p.value === selectedPriority);
                                    return match ? match.color : 'black';
                                })()
                                : 'black'
                        }}
                        onChange={this.handlePriorityChange}
                        value={selectedPriority}
                    >
                        <option value="" disabled>
                            {t({text: 'priority', user})}
                        </option>

                        {priorities.map((priority) => (
                            <option
                                key={priority.id}
                                value={priority.value}
                                style={{color: priority.color}}
                            >
                                {priority.icon} {priority.label}
                            </option>
                        ))}
                    </select>

                    {isTicket && (
                        <select
                            id="assign"
                            name="assignUser"
                            style={{...style.select_category}}
                            onChange={this.handleAssigneeChange}
                            value={assignee || ''}
                        >
                            <option value="" disabled>
                                {t({text: 'assignee', user})}
                            </option>

                            {users.map((usr) => (
                                <option key={usr.id} value={usr.id}>
                                    {usr.firstName} {usr.lastName}
                                </option>
                            ))}
                        </select>
                    )}

                    {features.includes(config.features.TICKETS) && (
                        <label className="checkbox_label" style={{display: 'block', fontSize: '14px'}}>
                            <input
                                type="checkbox"
                                name="isTicket"
                                checked={!!isTicket}
                                onChange={this.handleInputChange}
                            />
                            <Translate text="isTicket"/>
                        </label>
                    )}


                    {!isTicketDiv && (
                        <label className="checkbox_label" style={{
                            display: 'block', fontSize: '14px'
                        }}>
                            <input
                                type="checkbox"
                                name="silentMod"
                                checked={silentMod}
                                onChange={this.handleInputChange}
                            />
                            <Translate text="silentMod"/>
                        </label>
                    )}

                    <div className="buttons" style={style.buttonsWrapper}>
                        <SilverButton styles={{marginRight:'20px', fontSize: '12px'}} type={'button'} onClick={cancelAction} fontSize={'12px'}
                                      width={'100px'}
                                      children={<Translate text="cancel"/>}/>
                        {isTicketDiv ?
                            (
                                <BlueButton type={'button'} onClick={this.handleClick} styles={{fontSize:'12px'}} width={'120px'}
                                            children={<Translate text="save"/>}/>
                            )
                            :
                            (
                                <BlueButton type={'button'} onClick={this.handleClick} styles={{fontSize:'12px'}} width={'220px'}
                                            children={<Translate text="saveAndEnd"/>}/>
                            )}
                    </div>
                </div>
                }
            </Modal>
        );
    }
}

ConfirmModalFeedback.propTypes = {
    proceedAction: PropTypes.func.isRequired,
    cancelAction: PropTypes.func.isRequired,
    addNotification: PropTypes.func.isRequired,
    endConversation: PropTypes.func.isRequired,
    conversation: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    isOpen: state.confirmAction.isModalOpen, user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    proceedAction: () => {
        dispatch(proceedActionRedux());
    },
    cancelAction: () => {
        dispatch(cancelActionRedux());
    },
    ...bindActionCreators({
        addNotification: addNotificationAction,
        updateUserData: updateUserDataAction,
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmModalFeedback);



// WEBPACK FOOTER //
// ./src/components/ConfirmModalFeedback.jsx